export default class DeviceQR {
    constructor(ob) {
        this.mac = ob.mac;
        this.sn = ob.sn;
        this.in = ob.in;
    }

    static isDeviceQR(ob) {
        return ob !== null &&
            Object.keys(ob).length === 3 &&
            ob.mac !== undefined &&
            ob.sn !== undefined &&
            ob.in !== undefined;
    }
}


// WEBPACK FOOTER //
// ./src/domain/DeviceQR.js